// extracted by mini-css-extract-plugin
module.exports = {"radio":"styles_radio__1ZYrW","placeHolderShimmer":"styles_placeHolderShimmer__2pUVf","shimmer":"styles_shimmer__3D_Fo"};